import _styled from "styled-components";
import React from "react";
import { useCopyToClipboard } from "react-use";
import { getThemeStyle } from "~/features/ui/get-theme-style";
import { Icon } from "~/features/ui/icon";
import Checkmark from "~/public/icons/checkmark.svg";
import Copy from "~/public/icons/copy.svg";
type Props = {
  text: string;
};
export function CopyToClipboardText(props: Props) {
  const {
    text
  } = props;
  const [copiedState, copyToClipboard] = useCopyToClipboard();
  const [showCopiedStatus, setShowCopiedStatus] = React.useState(false);
  const themeStyle = getThemeStyle({
    mode: "light"
  });
  React.useEffect(() => {
    if (copiedState.value) {
      setShowCopiedStatus(true);
      setTimeout(() => {
        setShowCopiedStatus(false);
        copiedState.value = undefined;
      }, 2000);
    }
  }, [copiedState]);
  return <_StyledButton aria-label="Copy to clipboard" onClick={() => copyToClipboard(text || "")} $_css={[{
    "display": "flex",
    "alignItems": "center",
    "columnGap": "0.8rem",
    "wordBreak": "break-all",
    "borderWidth": "1px",
    "padding": "0.8rem",
    "textAlign": "left",
    "fontFamily": "Aeonik, ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
    "fontSize": "1.2rem",
    "lineHeight": "1.1",
    "letterSpacing": "0.024rem",
    "fontWeight": "400",
    "@media (min-width: 1024px)": {
      "fontSize": "1.4rem",
      "lineHeight": "1.1",
      "letterSpacing": "0.028000000000000004rem",
      "fontWeight": "400"
    }
  }, showCopiedStatus && {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(208 208 218 / var(--tw-bg-opacity))"
  }, themeStyle.border]}>
      <span>{text}</span>
      <Icon icon={showCopiedStatus ? Checkmark : Copy} />
    </_StyledButton>;
}
var _StyledButton = /*#__PURE__*/_styled("button").withConfig({
  displayName: "copy-to-clipboard-text___StyledButton",
  componentId: "sc-1l0aqod-0"
})(["", ""], p => p.$_css);